import {
  SegmentDoc,
  FilterRequest,
  SegmentResponse,
  SegmentsResponse,
  SegmentsLightResponse,
} from '@/types/entities';
import { ApiService } from './api.service';
import { endpoints } from './endpoints';

/**
 * Service for handling segment-related API calls
 */
export class SegmentsApiService extends ApiService {
  // Get all segments (reference data)
  getAll = async (): Promise<SegmentsLightResponse> => this.get(endpoints.segments.all);

  getFilteredSegments = async (filters: FilterRequest): Promise<SegmentsResponse> =>
    this.post(endpoints.segments.filtered, filters);

  deleteSegment = async (id: string): Promise<void> => this.delete(endpoints.segments.delete(id));

  getSegmentById = async (id: string): Promise<SegmentResponse> =>
    this.get(endpoints.segments.byId(id));

  createSegment = async (data: Partial<SegmentDoc>): Promise<SegmentDoc> =>
    this.post(endpoints.segments.create, data);

  updateSegment = async (id: string, data: Partial<SegmentDoc>): Promise<SegmentDoc> =>
    this.patch(endpoints.segments.update(id), data);
}

// Export a singleton instance
export const segmentsApiService = new SegmentsApiService();

// Named exports for convenience
export const {
  getAll: getSegments,
  getFilteredSegments,
  deleteSegment,
  getSegmentById,
  createSegment,
  updateSegment,
} = segmentsApiService;
